import {Alert, AlertTitle, Grid, Paper, Popper, Typography} from "@mui/material";
import {grey, orange} from "@mui/material/colors";
import UpdateIcon from "@mui/icons-material/Update";
import React from "react";
import {usePopperZIndex} from "../../../../misc/scroller/PopperZIndexProvider";

export function PreviousValuePopup(props: {
    anchor: HTMLElement|null;
    width: number;
    value: any;
    hasConflict?: boolean;
}) {

    const overrideZIndex = usePopperZIndex();

    return (
        <Popper open anchorEl={props.anchor} style={{
            // table cells (frozen columns, checkboxes) use z-indexes up to ~12; sit above them
            // so their content doesn't paint over this popup. overrideZIndex wins inside a dialog.
            zIndex: overrideZIndex ?? 1200,
        }}>
            <Paper elevation={3} style={{padding: 4, paddingLeft: 8, paddingRight: 8, minWidth: props.width, overflow: "hidden"}}>
                <Grid container spacing={1} alignItems="flex-start">
                    <Grid item style={{color: orange["800"]}}>
                        <div style={{height: 4}} />
                        <UpdateIcon color="inherit" />
                    </Grid>
                    <Grid item>
                        <Typography variant="caption" style={{lineHeight: "0.75em"}}>
                            Previous Value
                        </Typography>
                        {/* the cell renderer can carry interactive chrome (checkboxes, by-others toggles,
                            etc.); frame it and kill pointer events so it clearly reads as a read-only
                            snapshot of the cell rather than actions belonging to this popup */}
                        <div style={{
                            pointerEvents: "none",
                            userSelect: "none",
                            border: "1px solid " + grey["300"],
                            borderRadius: 4,
                            backgroundColor: grey["50"],
                            padding: "2px 6px",
                            minWidth: props.width,
                        }}>
                            {props.value || <i>blank</i>}
                        </div>
                    </Grid>
                </Grid>

                {props.hasConflict && (
                    <>
                        <div style={{height: 8}} />
                        <Alert severity="error" style={{maxWidth: 450}}>
                            <AlertTitle>
                                Conflicts with a Recent Change
                            </AlertTitle>

                            <div>
                                This row was also changed by another change that was
                                approved more recently, so this edit can't be applied.
                            </div>
                            <div style={{height: 8}} />
                            <div style={{display: "flex", gap: 16}}>
                                <div>
                                    <b>To keep this edit</b>
                                    <div>
                                        Duplicate this changeset or start a new one.
                                    </div>
                                </div>
                                <div>
                                    <b>To keep your other edits</b>
                                    <div>
                                        Reset this row to its original value from the row menu.
                                    </div>
                                </div>
                            </div>
                        </Alert>
                    </>
                )}
            </Paper>
        </Popper>
    )
}